module.exports = new __parcel__URL__("gif2.7729b7fa.webm").toString();